import React from 'react';
import styled, { css } from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  sectionMargins,
  sectionPaddings,
  standardColours,
} from '../styles';
import { Container, Heading, HtmlContent } from './ui';

const StyledContentBlocks = styled.article`
  ${({ isDetail }) => {
    if (isDetail) {
      return css`
        ${sectionMargins('30px', '60px')}
        color: ${standardColours.black};
      `;
    } else {
      return css`
        ${sectionPaddings('50px', '120px')}
        background-color: ${brandColours.primary};
        color: ${standardColours.white};
      `;
    }
  }};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 30px;

  ${minBreakpointQuery.small`
    margin-bottom: 40px;
  `}

  ${minBreakpointQuery.medium`
    margin-bottom: 50px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 60px;
  `}
`;

const StyledItems = styled.div`
  display: grid;
  gap: 30px;

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(2,1fr);
  `}

  ${minBreakpointQuery.medium`
    gap: 45px;
  `}

  ${minBreakpointQuery.mlarge`
    gap: 60px;
  `}

  ${minBreakpointQuery.large`
    grid-template-columns: repeat(3,1fr);
  `}
`;

const StyledItem = styled.div``;

const StyledSubHeading = styled.h3`
  margin-bottom: 12px;
  ${fontSize(18)};
  font-weight: ${fontWeights.medium};

  ${minBreakpointQuery.small`
    margin-bottom: 14px;
    ${fontSize(20)};
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 16px;
    ${fontSize(22)};
  `}
`;

const ContentBlocks = ({ heading, items, isDetail }) => (
  <StyledContentBlocks isDetail={isDetail}>
    <Container>
      <StyledHeading>{heading}</StyledHeading>
      <StyledItems>
        {items.map(({ heading, text }, id) => (
          <StyledItem key={id}>
            <StyledSubHeading>{heading}</StyledSubHeading>
            <HtmlContent html={text} />
          </StyledItem>
        ))}
      </StyledItems>
    </Container>
  </StyledContentBlocks>
);

export default ContentBlocks;
